import { FilePickerAction, FileProviderItemViewState, SelectedFilesSource } from 'owa-filepicker';
import { CreateAttachmentHandler } from '../../types/CreateAttachmentHandler';
import { InsertLinkHandler } from '../../types/InsertLinkHandler';
import {
    onCloudFilesSelected,
    onLocalFilesSelected,
    onRecentAttachmentFilesSelected,
} from '../../utils/onFilesSelected';
import { onFilesSelectedForInsert } from '../../utils/onFilesSelectedForInsert';

export function attachFilesForSelectedAction(
    createAttachmentHandler: CreateAttachmentHandler,
    insertLinkHandler: InsertLinkHandler,
    selectedFiles: File[] | FileProviderItemViewState[],
    source: SelectedFilesSource,
    action: FilePickerAction,
    supportsInsertLink: boolean
) {
    if (source === SelectedFilesSource.LocalComputerFiles) {
        onLocalFilesSelected(
            createAttachmentHandler,
            <File[]>selectedFiles,
            action === FilePickerAction.Insert,
            action === FilePickerAction.Share
        );
    } else if (source === SelectedFilesSource.ProviderFiles) {
        if (action === FilePickerAction.Share && supportsInsertLink && insertLinkHandler !== null) {
            onFilesSelectedForInsert(insertLinkHandler, selectedFiles, source);
        } else {
            const files = <FileProviderItemViewState[]>selectedFiles;
            if (action !== FilePickerAction.AttachAndShare) {
                onCloudFilesSelected(
                    createAttachmentHandler,
                    files,
                    action === FilePickerAction.Share
                );
            } else {
                onRecentAttachmentFilesSelected(createAttachmentHandler, files);
            }
        }
    }
}
